<template>
  <nav v-if="items.length" aria-label="Breadcrumb" class="breadcrumb">
    <ol itemscope itemtype="https://schema.org/BreadcrumbList">
      <li
        v-for="(item, index) in items"
        :key="item.name"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
      >
        <router-link v-if="item.to" itemprop="item" :to="item.to">
          <span itemprop="name">{{ item.name }}</span>
        </router-link>
        <span v-else itemprop="name">{{ item.name }}</span>
        <meta itemprop="position" :content="String(index + 1)">
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
